import useAuthStore from '@/stores/useAuthStore'
import { useMemo } from 'react'
import DraggableLayout from '../shared/DraggableLayout'

// Import shared components
import Business from '@/modules/Dashboard/components/shared/Business'
import WorkDays from '@/modules/Dashboard/components/shared/WorkDays'
import MyWorkdays from '../../shared/MyWorkdays'
import Notifications from '../../shared/Notifications'
import Events from '../../shared/Events'
import Paper from '@/components/Paper'
import TargetRevenue from '../../shared/TargetRevenue'
import QuoteOfTheDay from '../../shared/QuoteOfTheDay'
import InternalInformation from '../../shared/InternalInformation'
import { WidgetConfig } from '../shared/types'

const GeneralDashboard = () => {
    const employee = useAuthStore((state) => state.employee)

    // Storage key unique per employee
    const storageKey = useMemo(
        () => `dashboard_layout_general_${employee?.employee_id || 'default'}`,
        [employee?.employee_id]
    )

    // Widget configurations with colSpan (3, 4, 6, 8, or 12)
    const widgets: WidgetConfig[] = useMemo(
        () => [
            {
                id: 'quote_of_the_day',
                component: (
                    <Paper className="h-full">
                        <QuoteOfTheDay />
                    </Paper>
                ),
                colSpan: 12,
            },
            {
                id: 'target_revenue',
                component: (
                    <Paper className="h-full">
                        <TargetRevenue />
                    </Paper>
                ),
                colSpan: 6,
            },
            {
                id: 'business',
                component: (
                    <Paper className="h-full">
                        <Business />
                    </Paper>
                ),
                colSpan: 3,
            },
            {
                id: 'workday',
                component: (
                    <Paper className="h-full">
                        <WorkDays />
                    </Paper>
                ),
                colSpan: 3,
            },
            {
                id: 'notification',
                component: (
                    <Paper className="h-full">
                        <Notifications />
                    </Paper>
                ),
                colSpan: 9,
            },
            {
                id: 'internal-information',
                component: (
                    <Paper className="h-full">
                        <InternalInformation />
                    </Paper>
                ),
                colSpan: 9,
            },
            {
                id: 'events',
                component: (
                    <Paper className="h-full">
                        <Events />
                    </Paper>
                ),
                colSpan: 3,
            },
            {
                id: 'my_workdays',
                component: (
                    <Paper className="h-full">
                        <MyWorkdays />
                    </Paper>
                ),
                colSpan: 3,
            },
        ],
        []
    )

    return (
        <DraggableLayout
            widgets={widgets}
            storageKey={storageKey}
            department="DEFAULT"
        />
    )
}

export default GeneralDashboard
